var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnmarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9177_990)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9177_990)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9177_990",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9177_990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1237 44.487C24.6376 44.487 24.1515 44.4002 23.6654 44.2266C23.1793 44.053 22.7452 43.7925 22.3633 43.4453C20.1063 41.362 18.1098 39.3307 16.3737 37.3516C14.6376 35.3724 13.1879 33.454 12.0247 31.5964C10.8615 29.7387 9.97613 27.9505 9.36849 26.2318C8.76085 24.513 8.45703 22.8724 8.45703 21.3099C8.45703 16.1016 10.1324 11.9523 13.4831 8.86198C16.8338 5.7717 20.714 4.22656 25.1237 4.22656C29.5334 4.22656 33.4136 5.7717 36.7643 8.86198C40.115 11.9523 41.7904 16.1016 41.7904 21.3099C41.7904 22.8724 41.4865 24.513 40.8789 26.2318C40.2713 27.9505 39.3859 29.7387 38.2227 31.5964C37.0595 33.454 35.6098 35.3724 33.8737 37.3516C32.1376 39.3307 30.1411 41.362 27.8841 43.4453C27.5022 43.7925 27.0681 44.053 26.582 44.2266C26.0959 44.4002 25.6098 44.487 25.1237 44.487ZM25.1237 25.0599C26.2695 25.0599 27.2504 24.6519 28.0664 23.8359C28.8824 23.02 29.2904 22.0391 29.2904 20.8932C29.2904 19.7474 28.8824 18.7665 28.0664 17.9505C27.2504 17.1346 26.2695 16.7266 25.1237 16.7266C23.9779 16.7266 22.997 17.1346 22.181 17.9505C21.365 18.7665 20.957 19.7474 20.957 20.8932C20.957 22.0391 21.365 23.02 22.181 23.8359C22.997 24.6519 23.9779 25.0599 25.1237 25.0599Z",
    fill: "#D80B0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.9866,
    cy: 20.7601,
    r: 6.1507,
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9177_990",
    x: 5.45703,
    y: 1.22656,
    width: 43.334,
    height: 50.2617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9177_990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9177_990",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9177_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnmarker);
export default __webpack_public_path__ + "static/media/ownmarker.e3ca7d84a26b08c3184fccbc42806736.svg";
export { ForwardRef as ReactComponent };